import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/5_1.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Czemu nie, masz pan drugi koszyk?"
            question=""
            audio={audio}
            answers={{
                ans1: "Kto to jest ten Łukaszewski?",
                ans2: "A daleko do tego Tarszewa?",
            }}
            links={{
                link1: PAGES.p10,
                link2: PAGES.p11,
            }}
            content={
                <div>
                    <ul>
                        <li>Czemu nie. Masz pan drugi koszyk?</li>
                        <li>Och, stokrotne dzięki! Gdzieś tu leżał drugi… Żona specjalnie go wyplatała w nocy! – mówi, rozglądając się w pośpiechu. – Emil jestem, miło mi! Na garnitur dla syna zbieram, a Lejmer, mój sąsiad znaczy, obiecał mi dać materiału za te śliwki. Ach, ile jeszcze tego… Nie wiem, co on zrobi z tyloma śliwkami, ale i dla nas trochę zostanie. Zapraszam dziś wieczorem do Łukaszewskiego na kolację! Jestem twoim dłużnikiem, sam w tydzień bym z tym się nie uporał. Może chcesz się u mnie zatrzymać?</li>
                        <li>Za mną długa droga, więc ani kolacji, ani noclegu nie odmówię! Gdzie pan mieszka? </li>
                        <li>Tu niedaleko, w Tarszewie. Mam porządną chałupę z rudy darniowej!
                        </li>
                    </ul>
                </div>
            }
        />

    );
}